import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    CircularProgress
} from '@mui/material'
import styles from './styles.module.scss'

const DeleteConfirmationModal = ({
    deleteOpen,
    handleClose,
    idsToDelete,
    isLoading,
    essanceName = '',
    handleDelete,
}) => {

    const handleCloseDeleteDialog = () => {
        handleClose()
    }

    return (
        <Dialog
            open={deleteOpen}
            onClose={handleCloseDeleteDialog}
        >
            <Box className={styles.deleteModal}>
                <DialogTitle className={styles.deleteModalTitle}>
                    Confirm Delete {essanceName}
                    {idsToDelete.length > 1 && "s"}
                </DialogTitle>
                <DialogContent className={styles.deleteModalContent}>
                    <DialogContentText className={styles.deleteModalContentText}>
                        Are you sure you want to delete {idsToDelete.length > 1 ? "these" : "this"} {essanceName}{idsToDelete.length > 1 && "s"}? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={styles.deleteModalActions}>
                    <Button
                        className={styles.deleteModalButton}
                        onClick={handleCloseDeleteDialog}
                        color="secondary"
                        variant="outlined"
                    >
                        Cancel
                    </Button>
                    <Button
                        className={styles.deleteModalButton}
                        onClick={async () => await handleDelete()}
                        color="error"
                        variant="contained"
                        autoFocus
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress color="white" size={16} /> : 'Delete'}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default DeleteConfirmationModal